/**
 * Created by - Ashish Dewangan on 08-07-2024
 * Reason - Created home page
 */
import { useContext, useEffect, useState } from "react";

import homeStyle from "../Home/Home.module.css";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import { serviceData } from "../../Api/services";
import config, { baseURL } from "../../Api/config";
import { FaCheck } from "react-icons/fa";

import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";
import parse from "html-react-parser";
import { IoStar } from "react-icons/io5";

const Service = (props) => {
  const [serviceDetail, setServiceDetails] = useState({});

  const [isLoading, setIsLoading] = useState(true);

  const [sliderRef, instanceRef] = useKeenSlider({
    breakpoints: {
      "(min-width: 0px)": {
        slides: { perView: 1, spacing: 5 },
      },

      "(min-width: 250px)": {
        slides: { perView: 2, spacing: 10 },
      },
      "(min-width: 300px)": {
        slides: { perView: 2, spacing: 40 },
      },

      "(min-width:350px)": {
        slides: { perView: 3, spacing: 10 },
      },

      "(min-width: 450px)": {
        slides: { perView: 4, spacing: 5 },
      },

      "(min-width: 800px)": {
        slides: { perView: 5, spacing: 10 },
      },

      "(min-width: 1000px)": {
        slides: { perView: 6, spacing: 10 },
      },
      "(min-width: 1200px)": {
        slides: { perView: 7, spacing: 5 },
      },
      "(min-width: 1400px)": {
        slides: { perView: 8, spacing: 5 },
      },
    },
    slides: { perView: 2 },

    loop: true,
  });
  const fetchData = async () => {
    try {
      const response = await serviceData();
      setServiceDetails(response.service);
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      instanceRef.current?.next();
    }, 3000);

    return () => clearInterval(interval);
  }, [instanceRef]);

  const responsive2 = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1201 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1200, min: 1101 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet2: {
      breakpoint: { max: 1100, min: 901 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet3: {
      breakpoint: { max: 900, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 601 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile2: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <>
      {isLoading ? (
        <div className={homeStyle.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" />
        </div>
      ) : (
        <div className={homeStyle.mainContainer}>
              <div className={homeStyle.subContainer}>
        
          {serviceDetail?.length > 0 ? (
            <div 
            
            >
              <div
                className={homeStyle.title}
                style={{ fontSize: "var(--page-title-font-size)", marginBottom:'var(--page-title-margin-bottom)',paddingTop:'3%'}}
              
              >
                <span className={homeStyle.firstThree}>Ser</span>
                <span className={homeStyle.gradientText}>vice</span>
              </div>
              <div className={homeStyle.testimonialGrid}>
                {serviceDetail.map((testimonial, index) => (
                  <div key={index} className={homeStyle.testimonialCard}>
                    <h4 className={homeStyle.testimonialName}>
                      {testimonial.name}
                    </h4>
                    <p className={homeStyle.testimonialDescription}>
                      {testimonial.description &&
                      typeof testimonial.description === "string"
                        ? parse(testimonial.description)
                        : "No description available"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
        </div>

      )}
    </>
  );
};

export default Service;
